var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldIcon = function SvgShieldIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6BE",
    fillRule: "evenodd",
    d: "m7 0 7 2.667v4.175c0 4.642-2.924 7.692-7 9.158-4.076-1.466-7-4.516-7-9.158V2.667zM5.668 11.416c.17.167.446.167.617 0l5.67-5.622a.42.42 0 0 0 0-.606l-.616-.605a.444.444 0 0 0-.617 0L5.976 9.298 3.848 7.18a.447.447 0 0 0-.617 0l-.617.606a.423.423 0 0 0 0 .606z"
  })));
};
export default SvgShieldIcon;